import { Link } from "react-router-dom";
import Reveal from "@/components/Reveal";

export default function Footer() {
  return (
    <footer>
      <div className="wrap">
        <Reveal className="foot-brand-xl" data-testid="footer-brand-xl">KOSS 2027</Reveal>
        <div className="foot">
          <div>
            <Link className="brand" to="/" data-testid="footer-brand-logo">
              <span className="mark">KOS-LAB</span>
              <span>
                KOSS 2027
                <small>A KOS-LAB INITIATIVE · STRATEGY SUMMIT</small>
              </span>
            </Link>
            <p>Think clearly. Solve real problems. Lead better.</p>
            <p className="foot-theme">Theme · “Strategies for Impact and Innovation”</p>
          </div>
          <div className="footlinks">
            <Link to="/" data-testid="footer-link-home">Home</Link>
            <Link to="/lab" data-testid="footer-link-about">About</Link>
            <Link to="/team" data-testid="footer-link-team">Organising Team</Link>
            <Link to="/apply" data-testid="footer-link-apply">Applications</Link>
            <span>@KOSLab</span>
            <span>#KOSLab</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
